<template>
    <C1Button
        type="button"
        variant="neutral"
        class="af-btn-email-job afu-relative afu-truncate"
        :size="size"
        @click.stop.prevent="onClick()"
    >
        <FontAwesomeIcon
            :icon="['far', 'envelope']"
            size="sm"
            class="afu-mr-2 afu-text-neutral-dark"
        />
        {{ $t('label.email_to') }}
    </C1Button>
</template>

<script>
    import C1Button from '@/components/C1Components/C1Button';

    export default {
        name: 'EmailJob',

        components: {
            C1Button,
        },

        props: {
            jobTitle: {
                type: String,
                default: '',
            },

            jobUrl: {
                type: String,
                default: '',
            },
            size: {
                type: String,
                default: 'md',
                validator: value => ['sm', 'lg', 'md', 'xl'].includes(value),
            },
        },

        data() {
            return {
            };
        },

        computed: {
            getJobUrl() {
                return `https://${window.location.hostname}${this.jobUrl}`;
            },
        },

        methods: {
            onClick() {
                const subject = `Check out this job I found - ${this.jobTitle}`;
                let message = 'Hi [FRIEND NAME],\r\n';
                message += '\r\nCheck out this job that I found.\r\n';
                message += `\r\n${this.jobTitle}\r\n`;
                message += `\r\n${this.getJobUrl}\r\n\r\n\r\n`;
                message += '[MESSAGE TO FRIEND]\r\n\r\n';
                message += '\r\nKind regards,\r\n[SENDER NAME]';
                window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
            },
        },
    };
</script>
